import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const MyInvestments = lazy(() => import('../../container/investor/facilitator-investment/MyInvestments'));
const InvestmentDetails = lazy(
  () => import('../../container/investor/facilitator-investment/InvestmentDetail/investmentDetails'),
);
const InvestmentUpdate = lazy(() => import('../../container/investor/facilitator-investment/investmentUpdate'));
const InvestmentCreate = lazy(() => import('../../container/investor/facilitator-investment/investmentCreate'));
const InvestmentOpportunities = lazy(
  () => import('../../container/investor/facilitator-investment/InvestmentOpportunities'),
);

function Investments() {
  return (
    <Routes>
      <Route path="list" element={<MyInvestments />} />
      <Route path="opportunities" element={<InvestmentOpportunities />} />
      <Route path="create/:id" element={<InvestmentCreate />} />
      <Route path="detail/:id" element={<InvestmentDetails />} />
      <Route path="update/:id" element={<InvestmentUpdate />} />
    </Routes>
  );
}

export default Investments;
